// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__33Mmj","addWidgetButton":"Header_addWidgetButton__1Sjlg","dashboardTabs":"Header_dashboardTabs__BxRkd","active":"Header_active__3pVjV"};